/** Distinct hex colors (no #) for differentiating routes that share a GTFS color. */
export const UNIQUE_PALETTE = [
  "FF6B6B",
  "FFA94D",
  "FFD43B",
  "69DB7C",
  "38D9A9",
  "3BC9DB",
  "4DABF7",
  "748FFC",
  "9775FA",
  "DA77F2",
  "F783AC",
  "FF8787",
  "20C997",
  "15AABF",
  "339AF0",
  "5C7CFA",
  "845EF7",
  "CC5DE8",
  "F06595",
  "FA5252",
  "FD7E14",
  "FAB005",
  "82C91E",
  "12B886",
]

function normalize(color?: string) {
  return (color || "ffffff").replace(/^#/, "").toUpperCase()
}

function contrastText(hex: string) {
  const c = normalize(hex)
  const r = parseInt(c.slice(0, 2), 16)
  const g = parseInt(c.slice(2, 4), 16)
  const b = parseInt(c.slice(4, 6), 16)
  const luma = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luma > 0.62 ? "111111" : "FFFFFF"
}

/**
 * For each group of routes that share the same GTFS color, assign unique palette colors.
 * Routes that already have a unique color keep it.
 */
export function buildUniqueColorMap(
  routes: { id: string; color?: string }[]
): Record<string, { color: string; textColor: string }> {
  const byColor = new Map<string, string[]>()
  for (const route of routes) {
    const key = normalize(route.color)
    const list = byColor.get(key) || []
    list.push(route.id)
    byColor.set(key, list)
  }

  const result: Record<string, { color: string; textColor: string }> = {}
  let paletteIndex = 0

  for (const [original, ids] of byColor) {
    if (ids.length === 1) {
      result[ids[0]] = { color: original, textColor: contrastText(original) }
      continue
    }

    for (const id of ids) {
      const color = UNIQUE_PALETTE[paletteIndex % UNIQUE_PALETTE.length]
      paletteIndex += 1
      result[id] = { color, textColor: contrastText(color) }
    }
  }

  return result
}
